export const userCommunicationsEndpoint = 'player-ms/v1/user-communications';
export const getUserCommunicationsResourceId =
  'getUserCommunicationsResourceId';
export const postUserCommunicationsResourceId =
  'postUserCommunicationsResourceId';
export const getSummaryGameBreakEndpoint =
  'responsible-gaming/v1/getSummaryGameBreak';
export const getGameBreakPeriodsEndpoint =
  'responsible-gaming/v1/getGameBreakPeriods';
export const postSetGameBreak = 'responsible-gaming/v1/setGameBreak';
export const postRevokeGameBreak =
  'responsible-gaming/v1/revokePermanentGameBreak';
export const getAccountSessionAndLimitEndpoint =
  'responsible-gaming/v1/getAccountGameSessionAndLimit';
export const setAccountGameSessionAndLimitEndpoint =
  'responsible-gaming/v1/setAccountGameSessionAndLimit';
export const getSelfLimitationResourceId = 'getSelfLimitationResourceId';
export const postSelfLimitationResourceId = 'postSelfLimitationResourceId';
export const selfLimitationEndpoint = 'responsible-gaming/v1/self-limitation';
export const getSelfLimitationPendingResourceId =
  'getSelfLimitationPendingResourceId';
export const postSelfLimitationPendingResourceId =
  'postSelfLimitationPendingResourceId';
export const selfLimitationPendingEndpoint =
  'responsible-gaming/v1/self-limitation-pending';
export const getSelfLimitationPurposeResourceId =
  'getSelfLimitationPurposeResourceId';
export const postSelfLimitationPurposeResourceId =
  'postSelfLimitationPurposeResourceId';
export const selfLimitationPurposeEndpoint =
  'responsible-gaming/v1/self-limitation-purpose';
export const getSelfLimitationTypeSuitedResourceId =
  'getSelfLimitationTypeSuitedResourceId';
export const selfLimitationTypeSuitedEndpoint =
  'responsible-gaming/v1/self-limitation-type/suited';
export const SET_FEEDBACK_MESSAGE = 'pausaDalGioco/SET_FEEDBACK_MESSAGE';
export const CLEAR_FEEDBACK_MESSAGE = 'pausaDalGioco/CLEAR_FEEDBACK_MESSAGE';
export const START_POST_SELF_LIMITATION =
  'pausaDalGioco/START_POST_SELF_LIMITATION';
export const STOP_POST_SELF_LIMITATION =
  'pausaDalGioco/STOP_POST_SELF_LIMITATION';
